// NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class RankedList extends PureComponent {
  render() {
    const { children, heading, className, ...otherProps } = this.props;
    return (
      <div className={`RankedList ${className}`} {...otherProps}>
        <h2>Top {heading}</h2>
        <ol>{children}</ol>
      </div>
    );
  }
}

RankedList.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
};

RankedList.defaultProps = {
  children: [],
  className: '',
};

export default RankedList;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/RankedList.js